<div class="mct-flex mct-col mct-gap-4"   *ngIf="customFieldData">
  <div>
    <label>{{ customFieldData.Label }}</label>
    <span *ngIf="customFieldData.Required" class="ml-9">*</span>
  </div>
  <div [ngSwitch]="customFieldDisplayType">
    <textarea *ngSwitchCase="customFieldDisplayTypes.TextboxMultiline" class="form-control" pInputTextarea> </textarea>
    <p-select
      *ngSwitchCase="customFieldDisplayTypes.DropDownList"
      appendTo="body"
      [style]="{ width: '100%' }"
      [placeholder]="'common.select-one' | translate | ucfirst"
    ></p-select>
    <div *ngSwitchDefault>
      <div [ngSwitch]="customFieldType">
        <wl-date-selector *ngSwitchCase="customFieldDateTypes.Date"></wl-date-selector>
        <input *ngSwitchCase="customFieldDateTypes.Integer" type="number" class="form-control" />
        <input *ngSwitchCase="customFieldDateTypes.Decimal" type="number" class="form-control" />
        <input *ngSwitchDefault class="form-control" />
      </div>
    </div>
  </div>
</div>
